import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
  as: PropTypes.oneOf(['span', 'div'])
}

const Code = styled.span.attrs((props) => {
  return {
    as: props.as || 'span'
  }
})`
  color: ${(props) => props.theme.colors.onBlock};
  font-weight: ${(props) => props.theme.typography.code.fontWeight};
  font-family: ${(props) => props.theme.typography.code.fontFamily};
  font-size: ${(props) => props.theme.typography.code.fontSize}em;
  text-transform: ${(props) => props.theme.typography.code.case || 'none'};
  letter-spacing: ${(props) => props.theme.typography.code.spacing}em;
`

Code.propTypes = propTypes
export default Code
